import { create } from 'zustand';

export interface GrowlType {
   dismissible?: boolean
   type: string
   message: string
   uuid?: number
   autoclose?: number | boolean
}

interface Growls {
   new_uuid: number
   growls: GrowlType[]
}

interface GrowAction {
   addGrowl: (growl: GrowlType) => number
   removeGrowl: (id: number) => void
}

export const useGrowlStore = create<Growls & GrowAction>()(
   (set) => ({
      new_uuid: 1,
      growls: [],
      addGrowl: (growl) => {
         let uuid=0;
         set((state) => {
            uuid = state.new_uuid + 1;
            return {new_uuid:uuid, growls:[...state.growls, {...growl, uuid: uuid}]};
         });
         return uuid;
      },
      removeGrowl: (id: number) => set((state) => ({growls:[...state.growls].filter((g)=>id!==g.uuid)}))
   })
);
